import PropTypes from "prop-types";
import React, {Component} from "react";
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";
import {
    Container, Text
} from "../../../../../../components/index";
import {di} from "../../../../../../bottle";
import styles from "./styles";


// class definition
export class CategoryCard extends Component {

    static propTypes = {
        category: PropTypes.any,
        onPress: PropTypes.func,
    };

    static defaultProps = {
        selected: false,
        onPress: () => undefined
    };

    render() {

        // resolve inputs
        const {category, onPress} = this.props;

        return (
            <Container style={styles.backing}>
                <ButtonBase onClick={onPress}>
                    <Container
                        flex
                        style={styles.cardContainer}
                        justify="space-between"
                        direction="row"
                    >
                        <Container
                            flex
                            style={styles.header}
                            alignItems="flex-start"
                            justify="space-between"
                            alignContent="space-between"
                        >
                            <Text style={styles.title} bold>{category.name}</Text>
                            <Container style={styles.divider} />
                        </Container>
                        <img style={styles.image} src={di.assetManager.getImage(category.image.uri)}/>
                    </Container>
                </ButtonBase>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/CategoryCard.js